const saveToLocalStorage = (key, value) => {
    try {
        const valueToStore = JSON.stringify(value);
        localStorage.setItem(key, valueToStore);
    } catch (error) {
        console.error('Error saving to localStorage', error);
    }
};

const getFromLocalStorage = (key) => {
    try {
        const item = localStorage.getItem(key);
        return item ? JSON.parse(item) : null;
    } catch (error) {
        console.error('Error getting from localStorage', error);
        return null;
    }
};

export { saveToLocalStorage, getFromLocalStorage };
